<template>
    <div>
        <AppLeftScreen v-if="isDesktopVersion()">
            <template #content>
                <div class="w-3/5 rounded-lg px-2" :class="{'pb-[400px]' : $route.name == 'main' && isDesktopVersion()}">
                <article-banner :section="parent_section" ref="banner"></article-banner>

                <div class="text-gray-600 text-xs p-2 section-description"
                     v-if="$root.stripTags($root.getLangText(parent_section.descr)).length > 0"
                     v-html="$root.getLangText(parent_section.descr)">
                </div>

                <article-select-section v-if="Object.keys(sections).length > 1"
                                        :sections="sections"></article-select-section>

                <div class="products relative">
                    <div id="products" class="rounded-2xl pt-4 mt-4">
                        <loading v-if="loading"></loading>
                        <div class="content_products px-2 pb-2"
                             :class="parseInt(section.popup_product_id) == 0 ? 'mb-4' : ''"
                             :data-navbarid="'topmenu-item_' + section.id"
                             :data-id="section.id"
                             v-if="sections"
                             v-for="(section, index) in sections"
                             :key="`${index}`"
                             :id="'section_' + section.id">
                            <template>
                                <div
                                    :class="[ section.is_popup && $root.hotel.template !== 'accor' ? '' : '' ]"></div>

                                <article-products
                                    v-if="section.products.length > 0"
                                    :section="section"
                                    :parent-section="parent_section"
                                    :showCart="showCart">
                                </article-products>

                                <article-section v-else :item="section"></article-section>
                            </template>
                        </div>
                    </div>
                </div>

                <div class="leading-none text-gray-700 text-center pb-6"
                     v-html="$root.getLangText(parent_section.footer_text)"></div>
                    <app-footer></app-footer>
                </div>
            </template>
        </AppLeftScreen>

        <div v-else>
            <article-banner :section="parent_section" ref="banner"></article-banner>

            <div class="text-gray-600 text-xs p-2 section-description"
                 v-if="$root.stripTags($root.getLangText(parent_section.descr)).length > 0"
                 v-html="$root.getLangText(parent_section.descr)">
            </div>

            <article-select-section v-if="Object.keys(sections).length > 1"
                                    :sections="sections"></article-select-section>

            <div class="products relative">
                <div id="products" class="rounded-2xl pt-4 mt-4">
                    <loading v-if="loading"></loading>
                    <div class="content_products px-2 pb-2"
                         :class="parseInt(section.popup_product_id) == 0 ? 'mb-4' : ''"
                         :data-navbarid="'topmenu-item_' + section.id"
                         :data-id="section.id"
                         v-if="sections"
                         v-for="(section, index) in sections"
                         :key="`${index}`"
                         :id="'section_' + section.id">
                        <template>
                            <div :class="[ section.is_popup && $root.hotel.template !== 'accor' ? '' : '' ]"></div>

                            <article-products
                                v-if="section.products.length > 0"
                                :section="section"
                                :parent-section="parent_section">
                            </article-products>

                            <article-section v-else :item="section"></article-section>
                        </template>
                    </div>
                </div>
            </div>

            <div class="leading-none text-gray-700 text-center pb-6"
                 v-html="$root.getLangText(parent_section.footer_text)"></div>
        </div>
        <article-popup-display-working-hours></article-popup-display-working-hours>
        <article-extra-popup></article-extra-popup>
        <article-confirm-split-order></article-confirm-split-order>
        <article-product-with-properties-cart></article-product-with-properties-cart>
    </div>
</template>

<script>
    import ArticleBanner from './ArticleBanner';
    import ArticleExtraPopup from './ArticleExtraPopup';
    import ArticleProducts from './ArticleProducts';
    import ArticleProductCart from './ArticleProductCart';
    import ArticleProductWithPropertiesCart from "@/pages/Product/ArticleProductWithPropertiesCart.vue";
    import ArticleSelectSection from './ArticleSelectSection';
    import ArticlePopupDisplayWorkingHours from './ArticlePopupDisplayWorkingHours';
    import Loading from '../../components/article/ArticleLoading.vue';
    import AppLeftScreen from '../../components/layout/AppLeftScreen.vue';
    import { eventBus } from '../../main';
    import ArticleConfirmSplitOrder from './ArticleConfirmSplitOrder.vue';
    import ArticleSection from './ArticleSection.vue';
    import {AdultsOnlyProductWarning} from '@/components/mixins/AdultsOnlyProductWarning';
    import AppFooter from "@/components/layout/AppFooter.vue";

    export default {
        components: {
            AppFooter,
            Loading,
            ArticleBanner,
            ArticleProducts,
            ArticleExtraPopup,
            ArticleProductCart,
            ArticleProductWithPropertiesCart,
            ArticleSelectSection,
            ArticlePopupDisplayWorkingHours,
            ArticleSection,            
            ArticleConfirmSplitOrder,
            AppLeftScreen
        },
        
        mixins: [AdultsOnlyProductWarning],

        created() {
            this.$nextTick(() => {
                this.fetch();
            });

            eventBus.$on('show-cart', data => {
                this.showCart(data.item, data.section);
            });
        },

        data() {
            return {
                sections: [],
                parent_section: [],
                main_section: null,
                loading: false,
                time_loading: false,            
            }
        },

        methods: {
            async fetch() {
                this.loading = true;
                
                if (this.$root.hotel === undefined || this.$root.hotel.length == 0) {
                    await this.$root.getHotel();
                }                

                var url = process.env.VUE_APP_API_URL + 'hotels/' + this.$root.hotelCode + '/products/' + this.$route.params.id;
                await this.$http.get(url)
                    .then(response => {               
                        this.sections = response.data.data.sections;
                        this.parent_section = response.data.data.section; 
                        this.main_section = response.data.data.main_section;                       

                        this.$nextTick(() => {
                            this.afterFetchProducts();
                        });
                    });
                    
                this.loading = false;
            },

            showCart(item, perent_section = null) {
                if (item === null || item === undefined)
                    return;

                if (perent_section !== null && (!item.in_schedule || !perent_section.in_schedule)) {
                    return ;
                }

                if (item.external_link !== null && item.external_link !== '' && item.external_link !== undefined) {
                    window.open(item.external_link, '_blank');
                    return false;
                }                

                let section = this.sections.filter(one => one.id == item.section_id)[0];                    

                
                if (section.hide_order_button) {
                    return;
                }

                if (!item.in_schedule && this.displayScheduleText(item)) {
                    this.$modal.show('modal-display-working-hours', {
                        title: '',
                        text: this.displayScheduleText(item),
                    });

                    return false;
                }                

                if (!section.in_schedule && this.displayScheduleText(section)) {
                    this.$modal.show('modal-display-working-hours', {
                        title: '',
                        text: this.displayScheduleText(section),
                    });

                    return false;
                }

                if (!this.parent_section.in_schedule && this.displayScheduleText(this.parent_section) ) {
                    this.$modal.show('modal-display-working-hours', {
                        title: '',
                        text: this.displayScheduleText(this.parent_section),
                    });

                    return false;
                }                

                //var is_popup_product = this.popupProducts.findIndex(one => one == item.id) > -1;
                try {
                    var is_popup_product = section.is_popup || item.is_popup;
                    var cart_from_ls = localStorage['cart'] !== undefined && localStorage['cart'] ? JSON.parse(localStorage['cart']) : null;
                    
                    if (cart_from_ls) {
                        const is_has_split_section = cart_from_ls.products.some(product => {
                            const has_parent_section = product.parent_section &&
                                (product.parent_section.split_order || this.parent_section.split_order) &&
                                product.parent_section.id !== this.parent_section.id;

                            const has_main_section = product.main_section &&
                                (product.main_section.split_order || this.main_section.split_order) &&
                                product.main_section.id !== this.main_section.id;

                                console.log(has_parent_section, has_main_section);

                            return has_parent_section || has_main_section;
                        });

                        if ((is_popup_product || is_has_split_section) && cart_from_ls.products.length > 0) {
                            this.$modal.show('modal-confirm-split-order');
                            return false;
                        }
                    }
                } catch(e) {
                    console.error(e);
                }
                let beerSections = [6958, 6993];
                let is_adult_section = null;
                let is_16_section = null;

                if (this.$root.hotelCode == 'novotelgenevecentre' && beerSections.includes(item.section_id)) {
                    is_16_section = (localStorage.getItem('is_16') === undefined || localStorage.getItem('is_16') === null) && section.for_adult !== null && section.for_adult;
                }
                else {
                    is_adult_section = (localStorage.getItem('is_adult') === undefined || localStorage.getItem('is_adult') === null) && section.for_adult !== null && section.for_adult;
                }

                if (is_16_section) {
                    this.$modal.show('modal-extra', {item: item, section_id: null});

                    return false;
                }
                else if (is_adult_section) {
                    this.$modal.show('modal-extra', {item: item, section_id: null});

                    return false;
                } else {
                    if(this.checkIsAdultProduct(item)){
                        return false;
                    }
                }                

                var template = is_popup_product ? 'product-fast-cart' : 'product-cart';
                
                eventBus.$emit(template, {
                    product: JSON.stringify(item),
                    section: section,
                    parent_section: this.parent_section,
                    main_section: this.main_section,
                    from_recommendation: false,
                    action: {
                        type: 'create',
                        index_for_update: null,
                    }
                });

                this.$root.yandexGoal('goal - cart - start');
            },

            afterFetchProducts() {
                var section_id = this.$root.getQueryVariable('section-id');
                var lang = this.$root.getQueryVariable('lang');
                let openProductId = this.$root.getQueryVariable('product-id');

                this.$scrollTo('#app', 250, {
                    container: 'body',
                    easing: 'linear',
                    offset: 0,
                    force: true,
                    cancelable: true,
                    x: false,
                    y: true
                });

                // if guest open section via pre-arrival, we should set it's hidden page and safe our other page
                try {
                    if (this.parent_section.hide_back_button) {                        
                        if (document.querySelector('#homeBackButton')) {
                            document.querySelector('#homeBackButton').style.display = 'none';
                        }

                        if (document.querySelector('#bottomHomeBackButton')) {
                            document.querySelector('#bottomHomeBackButton').style.display = 'none';
                        }                        

                        if (document.querySelector('#bottomServices')) {
                            document.querySelector('#bottomServices').style.display = 'none';
                        }

                        this.$refs.banner.is_overlay = true;
                    } else {
                        if (document.querySelector('#homeBackButton')) {
                            document.querySelector('#homeBackButton').style.display = 'block';
                        }
                    }
                } catch (e) {
                    console.error(e);
                }

                if (lang) {
                    this.$root.currentLanguage = lang;
                }

                eventBus.$emit('modal-announcement', {
                    parent_section_id: this.parent_section.id,
                });

                if (section_id) {
                    var product = null;
                    var section = this.sections.filter(item => item.id ==  section_id)[0];
                    this.$scrollTo('#section_' + section_id, 500, {
                        container: 'body',
                        easing: 'linear',
                        offset: -145,
                        force: true,
                        cancelable: true,
                        x: false,
                        y: true
                    });
                }                

                try {
                    let openProductId = this.$root.getQueryVariable('product-id');
                    if (openProductId) {     
                        var allProducts = [];
                        this.sections.map(item => {
                            item.products.map(one => {
                                allProducts.push(one);
                            })
                        });
                        
                        var product = allProducts.filter(item => item.id == parseInt(openProductId));
                        if (product.length > 0) {
                        this.showCart(product[0]);
                        }

                        return;
                    }                    
                } catch(e) {
                    console.error(e);
                }                                  
                
                try {
                    if (this.sections && this.sections.length == 1 && this.sections.filter(item => item.is_popup).length == 1) {
                        let product = this.sections[0].products[0];
                        this.showCart(product);

                        return false;
                    }
                } catch (e) {
                    console.error(e);
                }
            },
        },
    }
</script>

<style>
    div.content_products ul li {
        list-style-type: disc;
    }

    div.content_products ul {
        padding-right: 5%;
        padding-left: 5%;
    }
    div.content_popup ul li {
        list-style-type: disc;
    }

    div.content_popup ul {
        padding: 5%;
    }

    .services .link_nav {
        min-width: 85.5px;
        display: block;
    }

    #scale-element {
        display: block;
        max-width: 100%;
        margin: 1rem auto;
        touch-action: none;
    }

    #scale-element.reset {
        transition: transform 0.3s ease-in-out;
    }
    .overflow-gesture-area{
        overflow: hidden;
    }

    #products { 
        background: #f4f4f4;
    }
</style>
